import { useAccount } from '@/domain/hooks/useAccount'
import { Button } from '@/ui/atoms/button/Button'
import { useChainId, useDisconnect } from 'wagmi'
import { generateWalletAvatar } from '@/features/navbar/logic/generateWalletAvatar'
import { AccountDisplay } from '@/ui/molecules/account-display/AccountDisplay'
import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { SUPPORTED_CHAIN_ID_TO_LOGOS } from '@/config/chain/constants'
import Image from 'next/image'

export function UserProfileCard() {
  const { disconnect } = useDisconnect()
  const account = useAccount()
  const [isCopied, setIsCopied] = useState(false)

  const chainId = useChainId()
  const networkIcon = SUPPORTED_CHAIN_ID_TO_LOGOS[chainId]
  const iconUrl = `https://icons-ckg.pages.dev/stargate-light/networks/${networkIcon}.svg`

  if (!account) return null

  async function copyToClipboard() {
    try {
      if (!account) return
      await navigator.clipboard.writeText(account)
      setIsCopied(true)
    } catch (error) {
      console.error('Failed to copy the link: ', error)
    }
  }

  return (
    <div className="px-6 py-4">
      <div className="mb-4 flex flex-col items-center justify-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-full border border-border-light bg-accent">
          <Image
            src={generateWalletAvatar(account)}
            width={24}
            height={24}
            alt="Wallet avatar"
            className="rounded-full "
          />
        </div>

        <div className="flex items-center gap-2">
          {networkIcon && <Image src={iconUrl} alt="" width={16} height={16} className="block rounded-full" />}
          <AccountDisplay address={account} shortenOptions={{ startLength: 7, endLength: 5 }} />
          <button
            onClick={() => copyToClipboard()}
            className="flex h-5 w-5 items-center justify-center rounded border border-border bg-muted"
          >
            {isCopied ? <Check className="h-3 w-3 text-primary" /> : <Copy className="h-3 w-3 text-muted-foreground" />}
          </button>
        </div>
      </div>

      <div className="flex justify-center border-border-light border-t pt-4">
        <Button variant="ghost" size="sm" className="text-muted-foreground" onClick={() => disconnect()}>
          Disconnect
        </Button>
      </div>
    </div>
  )
}
